import { initReactI18next, useTranslation as useTranslationI18next, Trans as TransI18next } from 'react-i18next';
import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import merge from 'deepmerge';
const languageStorageKey = 'lang';
const DEFAULT_OPTIONS = {
  whitelist: ['en', 'es'],
  lng: 'en',
  fallbackLng: 'en',
  nsSeparator: 'א',
  // used obscure character to avoid collision
  interpolation: {
    escapeValue: false // not needed for react as it escapes by default

  },
  detection: {
    lookupCookie: languageStorageKey,
    lookupQuerystring: languageStorageKey,
    lookupLocalStorage: languageStorageKey,
    caches: ['localStorage', 'cookie'],
    order: ['querystring', 'localStorage', 'cookie', 'navigator', 'sessionStorage', 'htmlTag']
  }
};

const initI18n = ({
  options,
  plugins = [],
  events = {}
}) => {
  Object.keys(events).forEach(evt => typeof events[evt] === 'function' && i18next.on(`${evt}`, events[evt]));
  [initReactI18next, LanguageDetector, HttpApi, ...plugins].reduce((i18nInstance, middleware) => {
    return i18nInstance.use(middleware);
  }, i18next).init(merge(DEFAULT_OPTIONS, options));
  return i18next;
};

export default initI18n;
export { useTranslationI18next, TransI18next };